import { CSRF_TOKEN } from "../constants";
import { upload } from "../api/cloudinary";

export default ({ path, redirect, remainingPhotos }) => ({
  loading: false,
  totalUploads: 0,
  completedUploads: 0,

  get label() {
    if (this.loading) {
      return `Uploading... (${this.completedUploads}/${this.totalUploads})`;
    }

    return "Select photos";
  },

  onClick() {
    this.$refs.input.click();
  },

  onChange(event) {
    if (event.target.files.length > remainingPhotos) {
      return alert(
        remainingPhotos === 0
          ? "You've reached the photo limit for this room."
          : `You can only upload ${remainingPhotos} more photo(s) for this room.`,
      );
    }

    this.handleFiles(event.target.files);
  },

  onBeforeUnload(event) {
    if (!this.loading) {
      return;
    }

    event.preventDefault();
    event.returnValue = "";
  },

  async handleFiles(files) {
    this.loading = true;
    this.totalUploads = files.length;
    this.completedUploads = 0;

    const uploads = Array.from(files).map((file) => this.uploadFile(file));

    try {
      await Promise.all(uploads);

      this.loading = false;

      this.onSuccess();
    } catch (error) {
      console.error(error);

      this.loading = false;

      alert("Something went wrong. Please try again later or contact support.");
    }
  },

  async uploadFile(file) {
    const photo = await upload(file);

    if (photo === null) {
      throw new Error("The photo could not be uploaded to Cloudinary.");
    }

    const response = await fetch(path, {
      headers: {
        Accept: "application/json",
        "X-CSRF-TOKEN": CSRF_TOKEN,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        public_id: photo.public_id,
      }),
    });

    if (!response.ok) {
      throw new Error("The photo could not be saved.");
    }

    this.completedUploads++;
  },

  onSuccess() {
    window.location.href = redirect;
  },
});
